export const DEFAULT_PAGE_THEME = 'default'

export const PAGE_THEMES = {
  mclaren: 'orange-dark',
  sungod: 'default',
  ln4: 'ln4',
  dr3: 'dr3'
}
